
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[blogUrl]",
      function () {
        return require("private-next-pages/blogs/[blogUrl]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[blogUrl]"])
      });
    }
  